export default {
    workspace: {"workspace": "Learning workspace", "administration": "Administration", "nextStep": "Your next step", "resumeHint": "Pick up where you left off and keep moving towards your certificate.", "searchCourses": "Search your courses", "allCourses": "All courses", "inProgress": "In progress", "completed": "Completed", "noMatches": "No matching courses", "filterHint": "Try another title or clear your filters.", "clearFilters": "Clear filters", "loadError": "Unable to load your dashboard", "loadErrorHint": "Your data is temporarily unavailable. Please try again.", "overview": "Platform overview", "overviewHint": "Manage your training operations from one place.", "completionRate": "Completion rate", "completionHint": "Completed enrollments out of all enrollments", "operations": "Learning operations", "operationsHint": "Review learner progress and payment issues", "enrollLearners": "Enroll learners", "enrollHint": "Assign courses to your teams", "analytics": "View analytics", "analyticsHint": "Explore training performance", "browseCourses": "Browse courses", "skipContent": "Skip to content"},
    journey: {"continueLearning": "Continue learning", "nextLesson": "Next lesson", "watchRequired": "Watch 95% to complete", "acknowledge": "Acknowledge reading", "freePreview": "Free preview", "openCertificate": "Open certificate", "requirements": "Complete every lesson and quiz to earn your certificate. Your best score for each current quiz counts.", "remaining": "{lessons} lessons and {quizzes} quizzes remaining", "available": "Available", "expired": "Expired", "revoked": "Revoked", "not_eligible": "Not eligible", "awaiting_approval": "Awaiting approval", "retry": "Retry", "accountNav": "My account & purchases"},
    // Navigation
    nav: {
      home: "Home",
      courses: "Courses",
      dashboard: "Dashboard",
      login: "Login",
      register: "Register",
      logout: "Logout",
      getStarted: "Get Started",
      myCourses: "My Courses",
      certificates: "Certificates",
      users: "Users",
      companies: "Companies",
      analytics: "Analytics",
      manageGroups: "Manage Groups",
      bulkEnroll: "Bulk Enroll",
      groupProgress: "Group Progress",
      aiSettings: "AI API Keys",
      stripeSettings: "Stripe Payments",
      emailNotifications: "Email Notifications",
      payments: "Payments",
      groupContent: "Content",
      groupPeople: "People",
      groupInsights: "Insights",
      groupMoney: "Money",
      groupSystem: "System"
    },
    
    // Landing Page
    landing: {
      overline: "Online Learning Platform",
      headline: "Master New Skills with Expert-Led Courses",
      subheadline: "Access high-quality courses, take quizzes to test your knowledge, and earn certificates upon completion. Join thousands of learners today.",
      startLearning: "Start Learning",
      browseCourses: "Browse Courses",
      featuresOverline: "Features",
      featuresTitle: "Everything You Need to Succeed",
      features: {
        videoCourses: "Video Courses",
        videoCoursesDesc: "Learn with high-quality video content from industry experts",
        quizzes: "Quizzes & Tests",
        quizzesDesc: "Test your knowledge and track your progress with interactive quizzes",
        certificates: "Certificates",
        certificatesDesc: "Earn customizable certificates upon successful course completion",
        forums: "Community Forums",
        forumsDesc: "Connect with fellow learners and discuss course topics",
        aiAssistant: "AI Assistant",
        aiAssistantDesc: "Get instant help from our AI-powered course assistant",
        materials: "Downloadable Materials",
        materialsDesc: "Access course materials anytime, even offline"
      },
      popularCourses: "Popular Courses",
      startJourney: "Start Your Learning Journey",
      viewAll: "View All",
      footer: "© 2026 Gabriel Consultant. All rights reserved."
    },
    
    // Auth
    auth: {
      welcomeBack: "Welcome Back",
      signInContinue: "Sign in to continue learning",
      createAccount: "Create Account",
      joinGabrielConsultant: "Join Gabriel Consultant and start learning",
      email: "Email",
      password: "Password",
      fullName: "Full Name",
      accountType: "Account Type",
      signIn: "Sign In",
      signUp: "Sign Up",
      noAccount: "Don't have an account?",
      haveAccount: "Already have an account?",
      student: "Student",
      clientManager: "Client Manager",
      forgotPassword: "Forgot password?",
      forgotPasswordHelp: "Enter your email and we'll send you a reset link.",
      sendResetLink: "Send Reset Link",
      passwordResetEmailSent:
        "If an account with that email exists, a password reset link has been sent.",
      backToSignIn: "Back to Sign In",
      resetPassword: "Reset Password",
      resetPasswordHelp: "Enter your new password below.",
      requestNewResetLink: "Request a new reset link",
      newPassword: "New Password",
      confirmPassword: "Confirm Password",
      updatePassword: "Update Password",
      passwordsMustMatch: "Passwords must match",
      passwordResetSuccess: "Password reset successful. Please sign in.",
      invalidResetLink: "Invalid or expired reset link."
    },
    
    // Dashboard
    dashboard: {
      welcomeBack: "Welcome back",
      continueJourney: "Continue your learning journey",
      adminDashboard: "Admin Dashboard",
      managePlatform: "Manage your learning platform",
      enrolledCourses: "Enrolled Courses",
      completedCourses: "Completed Courses",
      totalCourses: "Total Courses",
      totalStudents: "Students",
      totalEnrollments: "Enrollments",
      completions: "Completions",
      quickActions: "Quick Actions",
      manageCourses: "Manage Courses",
      manageUsers: "Manage Users",
      browseMore: "Browse More",
      startLearning: "Start Learning",
      noCoursesYet: "You haven't enrolled in any courses yet",
      inProgress: "In Progress",
      score: "Score",
      myCourses: "My Courses",
      certificatesLabel: "Certificates",
      completedLabel: "Completed",
      bulkEnrollTitle: "Bulk Enroll Students",
      selectCourse: "Select Course",
      selectStudents: "Select Students",
      chooseCourse: "Choose a course...",
      enrollCount: "Enroll {count} Students",
      lessonsCompleted: "Lessons Completed",
      analyticsTitle: "Analytics",
      analyticsOverview: "Platform-wide performance and engagement metrics"
    },
    
    // Courses
    courses: {
      allCourses: "All Courses",
      createCourse: "Create Course",
      createNew: "Create New Course",
      fillDetails: "Fill in the details to create a new course",
      title: "Title",
      description: "Description",
      thumbnailUrl: "Thumbnail URL",
      uploadThumbnail: "Course Thumbnail",
      thumbnailHint: "JPG or PNG, max 5MB",
      removeThumbnail: "Remove thumbnail",
      uploadingThumbnail: "Uploading thumbnail...",
      thumbnailUploaded: "Thumbnail uploaded",
      invalidImageType: "Only JPG and PNG images are allowed",
      videoUrl: "Video URL",
      videoType: "Video Type",
      price: "Price",
      specialOffer: "Special offer",
      specialOfferOptional: "Special offer (optional)",
      specialOfferPlaceholder: "Original price",
      specialOfferHint: "Set a higher original price to show a crossed-out price and Special offer badge on the courses page.",
      passingScore: "Passing Score",
      autoIssueCertificate: "Auto-issue certificate on passing score",
      autoIssueCertificateHint: "When enabled, students automatically receive a certificate the moment they meet this course's passing score.",
      freeCourse: "Free Course",
      privateCourse: "Private Course",
      courseType: "Course Type",
      paymentRequired: "Payment Required",
      language: "Language",
      category: "Category",
      filter: "Filter",
      search: "Search courses...",
      allLanguages: "All Languages",
      noCourses: "No courses available yet",
      noCoursesCreated: "No courses created yet",
      createFirst: "Create Your First Course",
      free: "Free",
      private: "Private",
      enrolled: "Enrolled",
      enrollNow: "Enroll Now",
      buyNow: "Buy Now",
      viewCertificate: "View Certificate",
      completeToGet: "Complete to get Certificate",
      passQuizToEarn: "Pass the quiz to earn your certificate",
      goToQuizzes: "Go to Quiz",
      certificateStepEnrolled: "Enrolled",
      certificateStepQuiz: "Pass quiz",
      certificateStepCert: "Certificate",
      quizRequiredForCert: "Required for certificate",
      quizPassed: "Passed",
      quizFailed: "Not passed — try again",
      lastScore: "Last score: {score}%",
      lessonProgress: "Lesson Progress",
      completedNoCertificate: "Course completed. No certificate was issued for this course.",
      watchedPercent: "{percent}% watched",
      lessons: "Lessons",
      quizzes: "Quizzes",
      aboutCourse: "About this course",
      noLessons: "No lessons added yet",
      noQuizzes: "No quizzes available yet",
      noMaterials: "No downloadable materials available",
      takeQuiz: "Take Quiz",
      overview: "Overview",
      materials: "Materials",
      aiAssistant: "AI Assistant",
      forum: "Forum",
      markComplete: "Mark Complete",
      enrollFree: "Enroll Free",
      deleteCourse: "Delete Course",
      editCourse: "Edit Course",
      saveChanges: "Save Changes",
      backToCourses: "Back to Courses",
      courseUpdated: "Course updated successfully",
      addLesson: "Add Lesson",
      editLesson: "Edit Lesson",
      saveLesson: "Save Lesson",
      lessonTitle: "Lesson title",
      lessonDescription: "Lesson description",
      lessonAdded: "Lesson added",
      lessonUpdated: "Lesson updated",
      lessonDeleted: "Lesson deleted",
      confirmDeleteLesson: "Are you sure you want to delete this lesson?",
      categoryPlaceholder: "e.g. Business",
      hasVideo: "Has video",
      trainingMaterials: "Training Materials",
      noMaterialsAdmin: "No training materials added yet.",
      uploadMaterial: "Upload training material",
      uploadMaterialHint: "PDF, TXT, DOC, DOCX, PPT, PPTX, XLS, XLSX, ZIP, JPG, or PNG up to 100MB.",
      uploadingMaterial: "Uploading material...",
      materialUploaded: "Training material uploaded",
      materialNamePlaceholder: "Material name (optional)",
      legacyMaterialHint: "Legacy external link — remove and re-upload the file.",
    },
    
    // Quiz
    quiz: {
      answerAll: "Answer all questions to complete the quiz",
      submit: "Submit Quiz",
      congratulations: "Congratulations!",
      tryAgain: "Try Again",
      yourScore: "Your Score",
      correct: "correct",
      passingScoreLabel: "Passing Score",
      viewCertificate: "View Certificate",
      downloadCertificate: "Download PDF",
      backToCourse: "Back to Course",
      certificateReady: "Your certificate is ready!",
      certificateIdLabel: "Certificate ID: {id}",
      backToDashboard: "Back to Dashboard",
      pleaseAnswer: "Please answer all questions",
      loadError: "Unable to load this quiz",
      loadErrorHint: "You may not be enrolled, or this quiz is no longer available.",
    },

    certificates: {
      overline: "Achievements",
      title: "My Certificates",
      certificateOfCompletion: "Certificate of Completion",
      awardedTo: "Awarded to",
      score: "Score",
      expired: "Expired",
      certificateId: "Certificate ID",
      issued: "Issued",
      validUntil: "Valid until",
      view: "View",
      downloadPdf: "Download PDF",
      emptyTitle: "No certificates yet",
      emptyDescription: "Complete a course to earn your first certificate!",
      browseCourses: "Browse courses",
    },

    quizBuilder: {
      title: "Quiz Builder",
      existingQuizzes: "Existing Quizzes",
      noQuizzes: "No quizzes added yet.",
      createQuiz: "Create multiple-choice quiz (A-E)",
      editQuiz: "Edit multiple-choice quiz (A-E)",
      cancelEdit: "Cancel edit",
      quizTitlePlaceholder: "Quiz title",
      autoGenerate: "Generate with AI",
      autoGenerateHint: "Use AI to create multiple-choice questions from one selected content source.",
      generationSources: "Content source",
      sourceMaterials: "Uploaded materials (PDF)",
      sourceCourseInfo: "Topic & description",
      generationSourcesHint: "Choose one source. Save the course after uploading PDFs or editing the topic and description.",
      questionCount: "Number of questions",
      questionCountOption: "{count} questions",
      generateQuestions: "Generate Questions",
      replaceDraftConfirm: "Replace the current draft questions with generated ones?",
      generatedSuccess: "Generated {count} quiz questions.",
      warnings: "Generation warnings ({count}): {preview}",
      csvImport: "Import Questions & Answers (CSV)",
      csvColumnsHint: "Required columns: question, option_a, option_b, option_c, option_d, option_e, correct_answer",
      csvCorrectAnswerHint: "correct_answer accepts A-E, 1-5, 0-4, or the exact option text.",
      csvExampleTitle: "CSV format example",
      csvAppendHint: "Import appends questions to the current draft quiz.",
      questionLabel: "Question",
      questionPlaceholder: "Enter a question",
      correctAnswer: "Correct Answer",
      addQuestion: "Add Question",
      draftQuestions: "Questions in Draft Quiz",
      correctAnswerLabel: "Correct answer",
      saveQuiz: "Save Quiz",
      createQuizButton: "Create Quiz"
    },
    
    // Certificate
    certificate: {
      myCertificates: "My Certificates",
      certificateOf: "Certificate of Completion",
      awardedTo: "Awarded to",
      noCertificates: "No certificates yet. Complete a course to earn your first certificate!",
      download: "Download",
      issuedOn: "Issued"
    },

    // Certificate Templates
    certificateTemplates: {
      manageTemplates: "Certificate Templates",
      description: "Create and manage printable certificate templates for your platform.",
      name: "Template Name",
      html: "HTML Template",
      primaryColor: "Primary Color",
      secondaryColor: "Secondary Color",
      background: "Background Artwork",
      default: "Default",
      createTemplate: "Create Template",
      createWithBuilder: "Create with Builder",
      editTemplate: "Edit Template",
      generateDefault: "Generate Default HTML",
      preview: "Preview",
      noTemplates: "No certificate templates yet. Create one to get started.",
      save: "Save Template",
      nameRequired: "Template name is required.",
      deleteConfirm: "Are you sure you want to delete this certificate template?",
      created: "Template created.",
      updated: "Template updated.",
      deleted: "Template deleted.",
      generated: "Default HTML generated.",
      limitNotice: "You can save up to {max} certificate templates. Delete one to create another.",
      limitReached: "Maximum of {max} certificate templates reached.",
      landscapeBackgroundHint: "Optional landscape background (A4, 297×210 mm). JPG or PNG, max 5MB. Custom image overrides preset artwork below.",
      landscapeBackgroundRequired: "Certificate background must be a landscape image (width greater than height).",
      portraitBackgroundRequired: "Certificate background must be a portrait image (height greater than width)."
    },

    certificateBuilder: {
      title: "Certificate Builder",
      description: "Configure a certificate for all courses or a specific course, then review and save.",
      scope: "Scope",
      scopeAll: "All courses",
      scopeCourse: "Specific course",
      course: "Course",
      startFrom: "Start from existing template",
      startFromHint: "Optional — copy settings from a template",
      templateName: "Template name",
      orientation: "Orientation",
      landscape: "Landscape",
      portrait: "Portrait",
      backgroundImage: "Background image",
      backgroundHint: "Drag and drop a JPG or PNG (max 5MB), or choose a file.",
      backgroundUploaded: "Background image uploaded.",
      uploadingBackground: "Uploading background…",
      removeBackground: "Remove background",
      invalidImageType: "Only JPG and PNG images are allowed.",
      fileTooLarge: "File is too large (max 5MB).",
      presetBackground: "Preset artwork",
      presetHint: "Used when no custom background image is set. Custom upload takes precedence.",
      bodyText: "Certificate text",
      livePreview: "Live preview",
      sampleNote: "Sample data — not a real certificate.",
      previewEmpty: "Enter certificate text to see a preview.",
      continueReview: "Continue to Review",
      reviewTitle: "Review certificate",
      reviewHint: "Check the near print-scale preview before saving.",
      reviewCheckAlignment: "Alignment looks correct for the chosen orientation",
      reviewCheckReadability: "Text is readable over the background",
      reviewCheckImage: "Background image quality is acceptable",
      back: "Back",
      save: "Save certificate",
      downloadPreviewPdf: "Download PDF preview",
      saved: "Certificate configuration saved.",
      discardConfirm: "Discard unsaved changes?",
      validationError: "Name, certificate text, and course (when scoped) are required.",
      openFromCourse: "Certificate Builder"
    },

    // Certificate background artworks
    // Certificate background artworks
    certificateBackgrounds: {
      plain: "Plain",
      geometric: "Geometric",
      waves: "Waves",
      guilloche: "Guilloché",
      corners: "Corner Flourish"
    },

    // Certificate Settings (ID naming + defaults)
    certificateSettings: {
      title: "Certificate Settings",
      description: "Configure how certificate IDs are generated and the default look for new certificates.",
      open: "Certificate Settings",
      idFormat: "Certificate ID Format",
      idFormatHint: "Available tokens: {seq} or {seq:6} (sequence), {year}, {month}, {day}, {random} or {random:4}, {course}. Text outside braces is used literally.",
      preview: "Next certificate ID",
      defaultBackground: "Default Background",
      defaultPrimaryColor: "Default Primary Color",
      defaultSecondaryColor: "Default Secondary Color",
      save: "Save Settings",
      saved: "Certificate settings updated.",
      cancel: "Cancel"
    },
    
    // Chat
    chat: {
      aiCourseAssistant: "AI Course Assistant",
      askQuestions: "Ask questions about the course content",
      startConversation: "Start a conversation with the AI assistant",
      askQuestion: "Ask a question..."
    },
    
    // Forum
    forum: {
      communityForum: "Community Forum",
      shareThoughts: "Share your thoughts or ask a question...",
      post: "Post",
      noDiscussions: "No discussions yet. Be the first to post!"
    },
    
    // Users
    users: {
      manageUsers: "Manage Users",
      name: "Name",
      email: "Email",
      role: "Role",
      actions: "Actions",
      admin: "Admin",
      student: "Student",
      clientManager: "Client Manager",
      company: "Company",
      addUser: "Add User",
      editUser: "Edit User",
      importUsers: "Import Users",
      filterByCompany: "Filter by company",
      allCompanies: "All Companies",
      selectCompany: "Select company",
      noCompany: "No company",
      noUsers: "No users found for this filter.",
      save: "Save",
      formDescription: "Create or update a user account.",
      newPasswordOptional: "New password (optional)",
      requiredFields: "Name and email are required.",
      passwordMinLength: "Password must be at least 8 characters.",
      confirmDelete: "Are you sure you want to delete this user?",
      created: "User created!",
      updated: "User updated!",
      deleted: "User deleted!",
      selectCompanyForImport: "Please select a company for import.",
      importEmpty: "No valid users found in import data.",
      importDescription: "Paste CSV data with columns: name, email, password (optional), role (optional).",
      csvData: "CSV data",
      csvPlaceholder: "name,email,password,role\nJane Doe,jane@example.com,password123,student"
    },

    // Companies
    companies: {
      manageCompanies: "Manage Companies",
      createCompany: "Create Company",
      editCompany: "Edit Company",
      name: "Company Name",
      description: "Description",
      trainings: "Trainings",
      selectTrainings: "Assigned Trainings",
      noTrainingsAssigned: "No trainings assigned",
      noTrainingsAvailable: "No trainings available yet",
      assignTrainingsHint: "Selected trainings will be available to users in this company.",
      unknownTraining: "Unknown training",
      manageUsers: "Manage Users",
      save: "Save",
      formDescription: "Create or update a company.",
      nameRequired: "Company name is required.",
      created: "Company created!",
      updated: "Company updated!",
      deleted: "Company deleted!",
      confirmDelete: "Are you sure you want to delete this company?",
      noCompanies: "No companies yet. Create one to start importing users."
    },
    
    // Groups
    groups: {
      manageGroupEnrollments: "Manage Group Enrollments",
      selectCourse: "Select Course",
      selectStudents: "Select Students",
      chooseCourse: "Choose a course...",
      selectCourseAndStudents: "Please select a course and at least one student",
      enrollStudents: "Enroll Students"
    },
    
    // Manager
    manager: {
      monitorProgress: "Monitor student progress across all courses",
      noEnrollments: "No enrollments yet",
      completionRate: "Completion Rate",
      viewDetails: "View Details",
      enrolledLabel: "enrolled",
      completedLabel: "completed",
      coursesTitle: "Courses",
      noCoursesWithEnrollments: "No courses with enrollments",
      selectCoursePrompt: "Select a course to view detailed progress",
      totalEnrolled: "Total Enrolled",
      inProgressLabel: "In Progress",
      avgScore: "Avg Score",
      studentColumn: "Student",
      statusColumn: "Status",
      scoreColumn: "Score",
      lessonsColumn: "Lessons",
      attemptsColumn: "Attempts",
      lastActivityColumn: "Last Activity"
    },

    // AI Settings
    aiSettings: {
      title: "AI API Keys",
      description: "Manage AI provider API keys and test connections.",
      defaultProvider: "Default Provider",
      defaultPrompt: "Default System Prompt",
      defaultPromptPlaceholder: "You are a helpful course assistant.",
      defaultPromptHint: "Base instructions sent to the AI assistant for every course. Leave blank to use the built-in default. Individual courses can add their own guidance on top of this.",
      deepseek: "DeepSeek",
      xai: "xAI",
      apiKey: "API Key",
      apiKeyHint: "Leave blank to keep the existing key.",
      model: "Model",
      enabled: "Enabled",
      testConnection: "Test Connection",
      testing: "Testing...",
      save: "Save Settings",
      saving: "Saving...",
      saved: "AI settings saved.",
      connectionOk: "Connected",
      connectionFailed: "Connection failed",
      notConfigured: "Not configured",
      latency: "{ms}ms",
      configureKey: "Please enter an API key to test.",
      deepseekHint: "Create a key at platform.deepseek.com",
      xaiHint: "Create a key at x.ai/api"
    },

    // Stripe Settings
    stripeSettings: {
      title: "Stripe Payments",
      description: "Configure Stripe so students can pay for courses at checkout.",
      setupTitle: "Setup guide",
      step1: "In Stripe Dashboard → Developers → API keys, create a Secret key (sk_…) or Restricted key (rk_…). Do not use a publishable pk_ key.",
      step2: "Paste the key below, then click Test Connection.",
      step3: "Create a webhook in Stripe pointing to the URL below, event: checkout.session.completed.",
      step4: "Paste the webhook signing secret (whsec_…) below and Save Settings.",
      webhookUrl: "Webhook endpoint URL",
      webhookUrlHint: "In Stripe → Developers → Webhooks, add this endpoint and select checkout.session.completed.",
      copyWebhookUrl: "Copy URL",
      webhookUrlCopied: "Webhook URL copied.",
      webhookUrlCopyFailed: "Could not copy URL. Copy it manually.",
      credentials: "Stripe credentials",
      hint: "Paste your Stripe secret or restricted key here. Values saved in admin override environment variables.",
      apiKey: "Secret / Restricted API Key",
      apiKeyPlaceholder: "sk_live_…, sk_test_…, rk_live_…, or rk_test_…",
      apiKeyHint: "Use sk_… or rk_… only (not pk_…). Leave unchanged to keep the existing key. Get keys from dashboard.stripe.com/apikeys.",
      webhookSecret: "Webhook signing secret",
      webhookSecretPlaceholder: "whsec_…",
      webhookSecretHint: "Required in production. Point Stripe webhooks at the URL above for checkout.session.completed.",
      currentSource: "Currently using: {source}",
      sourceDatabase: "Saved in admin settings",
      sourceEnvironment: "Environment variable",
      testConnection: "Test Connection",
      testing: "Testing...",
      save: "Save Settings",
      saving: "Saving...",
      saved: "Stripe settings saved.",
      connectionOk: "Connected",
      connectionFailed: "Connection failed",
      notConfigured: "Not configured",
      accountId: "Account ID",
      mode: "Mode",
      modeLive: "Live",
      modeTest: "Test",
      rejectPublishableKey: "Publishable keys (pk_…) cannot be used. Paste a Secret (sk_…) or Restricted (rk_…) key.",
      rejectInvalidApiKey: "API key must start with sk_… or rk_….",
      rejectInvalidWebhookSecret: "Webhook secret must start with whsec_….",
      currency: "Checkout currency",
      currencyHint: "Currency sent to Stripe Checkout and shown on course prices (e.g. HKD). Must match the amounts you enter for courses.",
      sourceDefault: "Default (HKD)",
      accountDefaultCurrency: "Stripe account default currency"
    },

    // Toast
    toast: {
      roleUpdated: "Role updated!",
      courseDeleted: "Course deleted!",
      confirmDeleteCourse: "Are you sure you want to delete this course?",
      enrolledSuccess: "Enrolled successfully!",
      posted: "Posted!",
      lessonComplete: "Lesson marked complete!",
      passedQuiz: "Congratulations! You passed!",
      failedQuiz: "You didn't pass. Try again!",
      answerAll: "Please answer all questions"
    },

    // Payment
    payment: {
      processing: "Processing Payment...",
      pleaseWait: "Please wait while we confirm your payment.",
      successful: "Payment Successful!",
      enrolledInCourse: "You have been enrolled in the course.",
      startLearning: "Start Learning",
      goToCourses: "Go to My Courses",
      amountPaid: "Amount paid",
      courseLabel: "Course",
      stillConfirming: "Still confirming...",
      stillConfirmingHint: "Your payment may still be processing. This can take a minute — you can check again or view your courses; your enrollment will appear once confirmed.",
      checkAgain: "Check Again",
      backToDashboard: "Back to Dashboard",
      nextStepHint: "Pass the course quiz to earn your certificate.",
      somethingWrong: "Something went wrong",
      contactSupport: "Please contact support if the issue persists.",
      checkout: "Checkout",
      completePurchase: "Complete your purchase",
      reviewOrder: "Review your order, then continue to Stripe's secure checkout.",
      signInToContinue: "Sign in on this page to continue to payment.",
      signInTitle: "Sign in to continue",
      signInDescription: "Log in to complete checkout for this course.",
      readyToPay: "Ready to pay",
      signedInAs: "Signed in as {email}",
      orderSummary: "Order summary",
      secureStripe: "Payments are processed securely by Stripe.",
      fullAccess: "Full course access",
      total: "Total",
      redirectNotice: "You'll be redirected to Stripe to finish payment. Your enrollment unlocks as soon as payment succeeds.",
      payAmount: "Pay {amount}",
      backToCourse: "Back to course",
      termsHint: "You are purchasing access to",
      alreadyEnrolled: "You are already enrolled in this course.",
      canceled: "Payment canceled. You can try again anytime."
    },

    // Admin Payments
    adminPayments: {
      title: "Payments",
      description: "Review and manage Stripe payment transactions.",
      totalRevenue: "Total Revenue",
      paid: "Paid",
      pending: "Pending",
      totalTransactions: "Total Transactions",
      filterByStatus: "Filter by status",
      allStatuses: "All statuses",
      statusPaid: "Paid",
      statusPending: "Pending",
      statusFailed: "Failed",
      sessionId: "Session ID",
      course: "Course",
      student: "Student",
      amount: "Amount",
      status: "Status",
      date: "Date",
      noTransactions: "No transactions yet",
      noTransactionsHint: "Payments will appear here once students complete checkout."
    },

    // Admin Certificates
    adminCertificates: {
      title: "Certificates",
      description: "Certificates are issued automatically to students who pass a course's minimum score.",
      tabIssued: "Issued",
      tabTemplates: "Templates",
      templatesNotice: "Templates define the default printable design used when certificates are issued. Set one as Default to apply it platform-wide.",
      totalCertificates: "Total Certificates",
      manageAutoIssue: "Certificate Settings",
      autoIssueNotice: "Certificates are issued automatically when a student meets a course's passing score. Use Certificate Settings to configure the certificate ID format and default styling.",
      customizeCertificate: "Customize Certificate",
      customizeDescription: "Update the visual style for this certificate.",
      previewCertificate: "Preview Certificate",
      previewDescription: "Render a fully filled certificate without issuing it. Use a real course and student, or sample values.",
      preview: "Preview",
      previewGenerate: "Generate Preview",
      previewDownloadPdf: "Download PDF Preview",
      previewHint: "This preview is not saved and does not consume a certificate ID from the sequence.",
      sampleCourse: "Sample course (no real course)",
      sampleCourseTitle: "Sample Course Title",
      sampleStudent: "Use sample student name",
      sampleStudentName: "Sample Student Name",
      selectCourse: "Select a course",
      selectStudent: "Select a student",
      scoreLabel: "Score",
      score: "Score (0-100)",
      template: "Template",
      primaryColor: "Primary Color",
      secondaryColor: "Secondary Color",
      background: "Background Artwork",
      applyToCourse: "Apply to all certificates for this course",
      applyToCourseHint: "When enabled, the style changes will be applied to every certificate for the selected course.",
      certificateId: "Certificate ID",
      course: "Course",
      student: "Student",
      language: "Language",
      issuedOn: "Issued",
      validUntil: "Valid Until",
      expired: "Expired",
      actions: "Actions",
      customize: "Customize",
      download: "Download",
      noCertificates: "No certificates yet",
      noCertificatesHint: "Certificates appear here once students pass a course's minimum score.",
      customized: "Certificate style updated.",
      filterByCourse: "Filter by course",
      allCourses: "All courses",
      previewCourseRequired: "Select a course or enter a sample course title.",
      previewStudentRequired: "Select a student or enter a sample student name."
    },

    // Common
    common: {
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      refresh: "Refresh",
      completed: "Completed",
      youtube: "YouTube",
      vimeo: "Vimeo"
    }
  };
